import React from 'react';
import { ContentArea } from '../../base/container/container';
import ImageCarousel from '../../base/imageCarousel/imageCarousel';
import './photos.css';

const photos = [
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-1.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-2.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-3.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-4.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-5.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-6.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-7.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/180317-tatwerk-8.jpg', caption: '@ Tatwerk Performative Forschung / © 2018 Frank Sperling' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/201116-greenhouse-1.jpg', caption: '@ Greenhouse Berlin' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/201116-greenhouse-2.jpg', caption: '@ Greenhouse Berlin' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/201116-greenhouse-3.jpg', caption: '@ Greenhouse Berlin' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/xxxxxx-kaufbar-1.jpg', caption: '@ Kaufbar Berlin' },
  { src: 'http://pornoundpiano.de/assets/media/img/slider/xxxxxx-kaufbar-2.jpg', caption: '@ Kaufbar Berlin' }
];

const Photos = () => {
  return(
    <ContentArea>
      <section className="photos-section" id="photos">
        <h2>Photos</h2>
        <ImageCarousel data={photos} autoplay={4000} />
      </section>
    </ContentArea>
  );
}

export default Photos;
